/* eslint-disable */
import moment from 'moment';

/**
 * getYesterday
 * @returns {Object} Returns object with dateFrom/dateTo
 */
const getYesterday = () => {
  const dateFrom = moment()
    .subtract(1, `days`)
    .startOf(`day`)
    .format(`YYYY-MM-DD`);
  const dateTo = moment()
    .subtract(1, `days`)
    .endOf(`day`)
    .format(`YYYY-MM-DD`);
  return { dateFrom, dateTo };
};

/**
 * getThisWeek
 * @returns {Object} Returns object with dateFrom/dateTo
 */
const getThisWeek = () => {
  const dateFrom = moment()
    .startOf(`isoWeek`)
    .format(`YYYY-MM-DD`);
  let dateTo = moment()
    .subtract(1, `days`)
    .format(`YYYY-MM-DD`);
  // if monday
  if (moment().weekday() === 1) {
    dateTo = moment().format(`YYYY-MM-DD`);
  }
  return { dateFrom, dateTo };
};

/**
 * getThisMonth
 * @returns {Object} Returns object with dateFrom/dateTo
 */
const getThisMonth = () => {
  const dateFrom = moment()
    .startOf(`month`)
    .format(`YYYY-MM-DD`);
  let dateTo = moment()
    .subtract(1, `days`)
    .format(`YYYY-MM-DD`);

  // if first
  if (moment().day() === 1) {
    dateTo = moment().format(`YYYY-MM-DD`);
  }
  return { dateFrom, dateTo };
};

/**
 * getPreviousWeek
 * @returns {Object} Returns object with dateFrom/dateTo
 */
const getPreviousWeek = () => {
  const dateFrom = moment()
    .subtract(1, `weeks`)
    .startOf(`isoWeek`)
    .format(`YYYY-MM-DD`);
  const dateTo = moment()
    .subtract(1, `weeks`)
    .endOf(`isoWeek`)
    .format(`YYYY-MM-DD`);
  return { dateFrom, dateTo };
};

/**
 * getPreviousMonth
 * @returns {Object} Returns object with dateFrom/dateTo
 */
const getPreviousMonth = () => {
  const dateFrom = moment()
    .subtract(1, `months`)
    .startOf(`month`)
    .format(`YYYY-MM-DD`);
  const dateTo = moment()
    .subtract(1, `months`)
    .endOf(`month`)
    .format(`YYYY-MM-DD`);
  return { dateFrom, dateTo };
};

/**
 * getLastTwoMonths
 * @returns {Object} Returns object with dateFrom/dateTo
 */
const getLastTwoMonths = () => {
  const dateFrom = moment()
    .subtract(2, `months`)
    .startOf(`month`)
    .format(`YYYY-MM-DD`);
  const dateTo = moment()
    .subtract(1, `day`)
    .format(`YYYY-MM-DD`);
  return { dateFrom, dateTo };
};

/**
 * getPreviousQuarter
 * @returns {Object} Returns object with dateFrom/dateTo
 */
const getPreviousQuarter = () => {
  const currentMonth = moment().month() + 1;
  let dateFrom = null;
  let dateTo = null;
  if (currentMonth <= 3) {
    dateFrom = moment()
      .subtract(1, `years`)
      .startOf(`year`)
      .add(9, `months`);
    dateTo = moment()
      .subtract(1, `years`)
      .endOf(`year`);
  } else if (currentMonth <= 6) {
    dateFrom = moment().startOf(`year`);
    dateTo = moment()
      .startOf(`year`)
      .add(2, `months`)
      .endOf(`month`);
  } else if (currentMonth <= 9) {
    dateFrom = moment()
      .startOf(`year`)
      .add(3, `months`)
      .startOf(`month`);
    dateTo = moment()
      .startOf(`year`)
      .add(5, `months`)
      .endOf(`month`);
  } else if (currentMonth <= 12) {
    dateFrom = moment()
      .startOf(`year`)
      .add(6, `months`);
    dateTo = moment()
      .startOf(`year`)
      .add(8, `months`)
      .endOf(`month`);
  }
  return { dateFrom: dateFrom.format(`YYYY-MM-DD`), dateTo: dateTo.format(`YYYY-MM-DD`) };
};

/**
 * getThisQuarter
 * @returns {Object} Returns object with dateFrom/dateTo
 */
const getThisQuarter = () => {
  const currentMonth = moment().month() + 1;
  let dateFrom = null;
  let dateTo = null;
  if (currentMonth <= 3) {
    dateFrom = moment().startOf(`year`);
    dateTo = moment()
      .startOf(`year`)
      .add(2, `months`)
      .endOf(`month`);
  } else if (currentMonth <= 6) {
    dateFrom = moment()
      .startOf(`year`)
      .add(3, `months`)
      .startOf(`month`);
    dateTo = moment()
      .startOf(`year`)
      .add(5, `months`)
      .endOf(`month`);
  } else if (currentMonth <= 9) {
    dateFrom = moment()
      .startOf(`year`)
      .add(6, `months`)
      .startOf(`month`);
    dateTo = moment()
      .startOf(`year`)
      .add(8, `months`)
      .endOf(`month`);
  } else if (currentMonth <= 12) {
    dateFrom = moment()
      .startOf(`year`)
      .add(9, `months`);
    dateTo = moment().endOf(`year`);
  }
  return {
    dateFrom: dateFrom.format(`YYYY-MM-DD`),
    dateTo: moment(dateTo).isAfter(Date.now())
      ? moment()
          .subtract(1, `days`)
          .format(`YYYY-MM-DD`)
      : dateTo.format(`YYYY-MM-DD`),
  };
};

export default {
  getLastTwoMonths,
  getPreviousMonth,
  getPreviousQuarter,
  getPreviousWeek,
  getThisMonth,
  getThisQuarter,
  getThisWeek,
  getYesterday,
};
